import axiosInstance from "./axiosInstance";
const api = {
  login: (userData) => axiosInstance.post("/login", userData),
  registerUser: (userData) => axiosInstance.post("/register", userData),
  updateProfile: (profileData, token) =>
    axiosInstance.put("/user/profile", profileData, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  getDepartments: () => axiosInstance.get("/departments"),
  getAlumniUsers: (token) =>
    axiosInstance.get("/users", {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  updateUserApproval: (userId, userData, token) =>
    axiosInstance.patch(`/users/${userId}/approve`, userData, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  bulkUpdateUserApproval: (userData, token) =>
    axiosInstance.patch("/users/approve/bulk", userData, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  getEvents: (token) =>
    axiosInstance.get("/events", {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  getBloodDonors: (token) =>
    axiosInstance.get("/blood-donors", {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  getBusinessCategories: (token) =>
    axiosInstance.get("/business-categories", {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  getBusinesses: (token) =>
    axiosInstance.get("/businesses", {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  getBusinessById: (businessId, token) =>
    axiosInstance.get(`/businesses/${businessId}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  updateBusiness: (businessId, businessData, token) =>
    axiosInstance.put(`/businesses/${businessId}`, businessData, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  createBusiness: (businessData, token) =>
    axiosInstance.post("/businesses", businessData, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  getJobForumPosts: (token) =>
    axiosInstance.get("/job-forum-posts", {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  getJobForumComments: (token) =>
    axiosInstance.get("/job-forum-comments", {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  getJobForumLikes: (token) =>
    axiosInstance.get("/job-forum-likes", {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  getNotifications: (payload, token) =>
    axiosInstance.request({
      url: "/notifications",
      method: "get",
      data: payload,
      params: payload,
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  markNotificationAsRead: (notificationId, token) =>
    axiosInstance.patch(
      `/notifications/${notificationId}/read`,
      {},
      {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      },
    ),
  markAllNotificationsAsRead: (token) =>
    axiosInstance.patch(
      "/notifications/read-all",
      {},
      {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      },
    ),
  createEvent: (eventData, token) =>
    axiosInstance.post("/events", eventData, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  getGalleryAlbums: (params, token) =>
    axiosInstance.get("/gallery-albums", {
      params,
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  getGalleryAlbumById: (albumId, params, token) =>
    axiosInstance.get(`/gallery-albums/${albumId}`, {
      params,
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  createGalleryAlbum: (albumData, token) =>
    axiosInstance.post("/gallery-albums", albumData, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  updateGalleryAlbum: (albumId, albumData, token) =>
    axiosInstance.put(`/gallery-albums/${albumId}`, albumData, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  deleteGalleryAlbum: (albumId, token) =>
    axiosInstance.delete(`/gallery-albums/${albumId}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  addGalleryAlbumImages: (albumId, imageData, token) =>
    axiosInstance.post(`/gallery-albums/${albumId}/images`, imageData, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  updateGalleryImage: (imageId, imageData, token) =>
    axiosInstance.put(`/gallery-images/${imageId}`, imageData, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  deleteGalleryImage: (imageId, token) =>
    axiosInstance.delete(`/gallery-images/${imageId}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  createJobForumPost: (postData, token) =>
    axiosInstance.post("/job-forum-posts", postData, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  updateJobForumPost: (postId, postData, token) =>
    axiosInstance.put(`/job-forum-posts/${postId}`, postData, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  createJobForumLike: (likeData, token) =>
    axiosInstance.post("/job-forum-likes", likeData, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  updateJobForumLike: (likeId, likeData, token) =>
    axiosInstance.put(`/job-forum-likes/${likeId}`, likeData, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  createJobForumComment: (commentData, token) =>
    axiosInstance.post("/job-forum-comments", commentData, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  updateJobForumComment: (commentId, commentData, token) =>
    axiosInstance.put(`/job-forum-comments/${commentId}`, commentData, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  createFeedback: (feedbackData, token) =>
    axiosInstance.post("/event-feedback", feedbackData, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
  getFeedback: (token) =>
    axiosInstance.get("/event-feedback", {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    }),
};
export default api;
